/*
 *
 * actions
 *
 */

import {
  LOAD_MASTER_DEPARTMENT,
  LOAD_MASTER_DEPARTMENT_SUCCESS,
  LOAD_MASTER_DEPARTMENT_ERROR,
  LOAD_MASTER_DESIGNATION,
  LOAD_MASTER_DESIGNATION_SUCCESS,
  LOAD_MASTER_DESIGNATION_ERROR,
  LOAD_ROLE,
  LOAD_ROLE_SUCCESS,
  LOAD_ROLE_ERROR,
  LOAD_LOGINSHIFTS,
  LOAD_LOGINSHIFTS_SUCCESS,
  LOAD_LOGINSHIFTS_ERROR,
  LOAD_LOP_SETTING,
  LOAD_LOP_SETTING_SUCCESS,
  LOAD_LOP_SETTING_ERROR,
  LOAD_MASTER_HOLIDAY,
  LOAD_MASTER_HOLIDAY_SUCCESS,
  LOAD_MASTER_HOLIDAY_ERROR

} from "./constants";

//loadMasterDepartment
export function loadMasterDepartment(searchFilter) {
    return {
        type: LOAD_MASTER_DEPARTMENT,
        searchFilter
    }
}

export function loadMasterDepartmentSuccess(departmentList, success) {
    return {
        type: LOAD_MASTER_DEPARTMENT_SUCCESS,
        departmentList,
        success,
    }
}

export function loadMasterDepartmentError(error) {
    return {
        type: LOAD_MASTER_DEPARTMENT_ERROR,
        error
    }
}

//loadMasterDesignation
export function loadMasterDesignation(searchFilter) {
    return {
        type: LOAD_MASTER_DESIGNATION,
        searchFilter
    }
}

export function loadMasterDesignationSuccess(designationList, success) {
    return {
        type: LOAD_MASTER_DESIGNATION_SUCCESS,
        designationList,
        success,
    }
}

export function loadMasterDesignationError(error) {
    return {
        type: LOAD_MASTER_DESIGNATION_ERROR,
        error
    }
}


//loadRole
export function loadRole(searchFilter) {
    return {
        type: LOAD_ROLE,
        searchFilter
    }
}

export function loadRoleSuccess(roleList, success) {
    return {
        type: LOAD_ROLE_SUCCESS,
        roleList,
        success,
    }
}

export function loadRoleError(error) {
    return {
        type: LOAD_ROLE_ERROR,
        error
    }
}

//loadLoginShifts
export function loadLoginShifts(searchFilter) {
    return {
        type: LOAD_LOGINSHIFTS,
        searchFilter
    }
}

export function loadLoginShiftsSuccess(loginShiftList, success) {
    return {
        type: LOAD_LOGINSHIFTS_SUCCESS,
        loginShiftList,
        success,
    }
}

export function loadLoginShiftsError(error) {
    return {
        type: LOAD_LOGINSHIFTS_ERROR,
        error
    }
}


//loadLopSetting
export function loadLopSetting(searchFilter) {
    return {
        type: LOAD_LOP_SETTING,
        searchFilter
    }
}

export function loadLopSettingSuccess(lopSettingList, success) {
    return {
        type: LOAD_LOP_SETTING_SUCCESS,
        lopSettingList,
        success,
    }
}

export function loadLopSettingError(error) {
    return {
        type: LOAD_LOP_SETTING_ERROR,
        error
    }
}


//holiday
export function loadMasterHoliday(searchFilter) {
    return {
        type: LOAD_MASTER_HOLIDAY,
        searchFilter
    }
}

export function loadMasterHolidaySuccess(masterHolidayList, success) {
    return {
        type: LOAD_MASTER_HOLIDAY_SUCCESS,
        masterHolidayList,
        success,
    }
}

export function loadMasterHolidayError(error) {
    return {
        type: LOAD_MASTER_HOLIDAY_ERROR,
        error
    }
}


const actions = {
    loadMasterDepartment,
    loadMasterDepartmentSuccess,
    loadMasterDepartmentError,
    loadMasterDesignation,
    loadMasterDesignationSuccess,
    loadMasterDesignationError,
    loadRole,
    loadRoleSuccess,
    loadRoleError,
    loadLoginShifts,
    loadLoginShiftsSuccess,
    loadLoginShiftsError,
    loadLopSetting,
    loadLopSettingSuccess,
    loadLopSettingError,
    loadMasterHoliday,
    loadMasterHolidaySuccess,
    loadMasterHolidayError
}


export default actions;